<template>
  <SSection
    v-for="(item, index) in items"
    :key="index"
    :has-separator="false"
    :mobile-full="true"
  >
    <SCtaCard v-bind="item" />
  </SSection>
</template>
<script setup lang="ts">
import type { propsInterface as sCtaCardProps } from '~~/modules/design-system/sections/s-cta-card/s-cta-card.vue'

export interface propsInterface {
  items: sCtaCardProps[]
}

defineProps<propsInterface>()
</script>
